<div class="sd-form iam">
  <div class="sd-form__head">
    <div class="sd-form__head-text iam__head">
      <span class="ds-head-icon" aria-hidden="true">
        <svg viewBox="0 0 20 20" fill="none">
          <path d="M16 10a6 6 0 1 1-1.76-4.24" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
          <path d="M16 4v3h-3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </span>
      <div>
        <h3 class="sd-form__title">Daily transaction sync</h3>
        <p class="sd-form__subtitle">New bank transactions from Xero, every morning</p>
      </div>
    </div>
    <button type="button" class="sd-icon-btn" aria-label="Close" (click)="close()">
      <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
      </svg>
    </button>
  </div>

  <div class="sd-form__body">
    <p class="ds-loading" *ngIf="loading">Loading…</p>

    <ng-container *ngIf="!loading && state">
      <div class="iam-card" [class.is-active]="mode === 'active'" [class.is-locked]="mode === 'upgrade' || mode === 'ask-admin'">
        <div class="iam-card__head">
          <span class="iam-card__icon" aria-hidden="true">
            <svg viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="7" stroke="currentColor" stroke-width="1.6" />
              <path d="M10 6v4l2.5 1.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
            </svg>
          </span>
          <div class="iam-card__title-wrap">
            <span class="iam-card__title">Every day at {{ state.runTime }}</span>
            <span class="iam-badge iam-badge--active" *ngIf="mode === 'active'"><span class="iam-dot"></span> Active</span>
            <span class="iam-badge" *ngIf="mode === 'upgrade'">
              <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <rect x="3.5" y="7" width="9" height="6.5" rx="1.5" stroke="currentColor" stroke-width="1.4" />
                <path d="M5.5 7V5a2.5 2.5 0 015 0v2" stroke="currentColor" stroke-width="1.4" />
              </svg>
              Paid plans
            </span>
          </div>
        </div>

        <ng-container *ngIf="mode !== 'active'">
          <p class="iam-card__lead">Keep Transactions up to date without pressing Import.</p>
          <ul class="iam-list">
            <li>Imports the new transactions from Xero every morning at {{ state.runTime }}</li>
            <li>Only the bank accounts you choose, reconciled and not</li>
            <li>Skips anything already imported, so nothing appears twice</li>
          </ul>
        </ng-container>

        <ng-container *ngIf="mode === 'active'">
          <p class="iam-card__lead">
            Switched on{{ state.activatedUtc ? ' ' + (state.activatedUtc | date:'d MMM y') : '' }}. New transactions arrive every morning at {{ state.runTime }}.
          </p>
          <p class="iam-card__hint" *ngIf="lastRunLine">{{ lastRunLine }}</p>
          <p class="iam-card__hint">It runs as a workflow you can see in <a routerLink="/automate" (click)="close()">Flows</a>.</p>
        </ng-container>

        <p class="iam-card__hint" *ngIf="mode === 'activate' && options?.justUpgraded">
          Your new plan includes the daily sync. Choose the accounts below and switch it on.
        </p>
        <p class="iam-card__hint" *ngIf="mode === 'ask-admin'">
          Your plan includes the daily sync. Ask an admin of this organisation to switch it on.
        </p>
        <p class="iam-card__hint" *ngIf="mode === 'upgrade'">Available on paid plans. Upgrade to switch it on.</p>
      </div>

      <!-- What to import, and whose 10:00. -->
      <ng-container *ngIf="canEdit">
        <div class="ds-field">
          <div class="ds-field__head">
            <span class="ds-field__label">Bank accounts</span>
            <span class="ds-field__meta">
              {{ chosenIds.length }} of {{ accounts.length }} selected
              <button type="button" class="ds-link" *ngIf="filteredAccounts.length > 1" (click)="toggleAll(!allChosen)">
                {{ allChosen ? 'Clear all' : 'Select all' }}
              </button>
            </span>
          </div>
          <div class="ds-accounts-box" *ngIf="accounts.length > 0; else noAccounts">
            <div class="ds-search" *ngIf="accounts.length > 5">
              <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <circle cx="7" cy="7" r="4.75" stroke="currentColor" stroke-width="1.4" />
                <path d="M10.5 10.5L13.5 13.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
              </svg>
              <input type="text" [(ngModel)]="accountQuery" placeholder="Search accounts" autocomplete="off"
                     aria-label="Search accounts" />
              <button type="button" class="ds-search__clear" *ngIf="accountQuery" (click)="accountQuery = ''"
                      aria-label="Clear search">
                <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
                  <path d="M4.5 4.5l7 7M11.5 4.5l-7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                </svg>
              </button>
            </div>
          <div class="ds-accounts">
            <p class="ds-none" *ngIf="!filteredAccounts.length">No account matches "{{ accountQuery }}".</p>
            <label class="ds-account" *ngFor="let a of filteredAccounts">
              <input type="checkbox" [(ngModel)]="chosen[a.accountID]" [disabled]="busy" />
              <span class="ds-account__icon" [class.ds-account__icon--card]="a.kind === 'card'" aria-hidden="true">
                <ng-container *ngIf="a.kind === 'card'"><svg viewBox="0 0 16 16" fill="none"><rect x="1.75" y="3.5" width="12.5" height="9" rx="1.5" stroke="currentColor" stroke-width="1.3" /><path d="M1.75 6.5h12.5M4 10h2.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" /></svg></ng-container>
                <ng-container *ngIf="a.kind !== 'card'"><svg viewBox="0 0 16 16" fill="none"><path d="M2 6l6-3.5L14 6M3 13.5h10M4 6.5v5M6.67 6.5v5M9.33 6.5v5M12 6.5v5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" /></svg></ng-container>
              </span>
              <span class="ds-account__text">
                <span class="ds-account__name">{{ a.name }}</span>
                <span class="ds-account__detail" *ngIf="a.detail">{{ a.detail }}</span>
              </span>
            </label>
          </div>
          </div>
          <ng-template #noAccounts>
            <p class="ds-empty">No bank accounts from Xero yet. Connect Xero from Settings › Integrations.</p>
          </ng-template>
        </div>

        <div class="ds-field">
          <label class="ds-field__label" for="ds-tz">Timezone</label>
          <!-- Searchable: there are 400-odd zones. On the body, so the dialog's scroll does not clip it. -->
          <ng-select labelForId="ds-tz" class="ds-tz-select" [items]="zoneOptions" bindValue="id" bindLabel="label"
                     [(ngModel)]="timeZoneId" [searchFn]="searchZone" [clearable]="false" [disabled]="busy"
                     appendTo="body" placeholder="Search a city or region" notFoundText="No timezone matches">
            <ng-template ng-option-tmp let-zone="item">
              <span class="ds-tz-option">
                <span>{{ zone.label }}</span>
                <span class="ds-tz-offset" *ngIf="zone.offset">{{ zone.offset }}</span>
              </span>
            </ng-template>
          </ng-select>
          <span class="ds-hint">It runs at {{ state.runTime }} in this timezone.</span>
        </div>
      </ng-container>
    </ng-container>

    <p class="sd-form__error" *ngIf="errorMessage">{{ errorMessage }}</p>

    <!-- What switching on is doing while it runs: it can take a while the first time. -->
    <div class="ds-progress" *ngIf="busy && progressLine" role="status" aria-live="polite">
      <span class="ds-progress__spinner" aria-hidden="true"></span>
      <span>{{ progressLine }}</span>
    </div>
  </div>

  <div class="sd-form__footer">
    <ng-container [ngSwitch]="loading ? 'loading' : mode">
      <ng-container *ngSwitchCase="'loading'">
        <button type="button" class="sd-btn sd-btn--secondary" (click)="close()">Close</button>
        <button type="button" class="sd-btn sd-btn--primary" disabled>Loading…</button>
      </ng-container>
      <ng-container *ngSwitchCase="'activate'">
        <button type="button" class="sd-btn sd-btn--secondary" (click)="close()">Not now</button>
        <button type="button" class="sd-btn sd-btn--primary" (click)="save()" [disabled]="busy || accounts.length === 0">
          {{ busy ? 'Switching on…' : 'Switch on daily sync' }}
        </button>
      </ng-container>
      <ng-container *ngSwitchCase="'upgrade'">
        <button type="button" class="sd-btn sd-btn--secondary" (click)="close()">Not now</button>
        <button type="button" class="sd-btn sd-btn--primary" (click)="upgrade()">Upgrade to switch on</button>
      </ng-container>
      <ng-container *ngSwitchCase="'active'">
        <button type="button" class="sd-btn sd-btn--secondary" (click)="deactivate()" [disabled]="busy">
          {{ busy ? 'Turning off…' : 'Turn off' }}
        </button>
        <button type="button" class="sd-btn sd-btn--primary" (click)="save()" [disabled]="busy">
          {{ busy ? 'Saving…' : 'Save' }}
        </button>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <button type="button" class="sd-btn sd-btn--primary" (click)="close()">Done</button>
      </ng-container>
    </ng-container>
  </div>
</div>
